var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"title has-text-grey-dark is-size-4",class:{ 'margin-bottom-1': !_vm.skipMarginBottom }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }